import { BulkNotification, NotificationStatus } from "../../../types/types";

import styles from "./NotificationProgressBar.module.scss";

interface NotificationProgressBarProps {
  bulkNotification: BulkNotification;
}

export const NotificationProgressBar = ({
  bulkNotification,
}: NotificationProgressBarProps): JSX.Element => {
  const total = bulkNotification.notifications.length;
  const completed = bulkNotification.notifications.filter(
    (n) => n.status !== NotificationStatus.Info,
  ).length;
  const percentage = total > 0 ? (completed / total) * 100 : 0;

  return (
    <div className={styles.progress_bar}>
      <div className={styles.fill} style={{ width: `${percentage}%` }} />
    </div>
  );
};
